import dayjs from 'dayjs'
import { TESTS_TYPES_MAP } from '../../../inputComponents/investigation/components/InvestigationDateComponent'

function isValidDiagnosis(diagnosis, isUsedForPrinting = false) {
  const title = diagnosis?.title || diagnosis?.label
  const val = diagnosis?.id || diagnosis?.value

  if (!title || title?.trim() === '') {
    return false
  }
  if (!val || val?.trim() === '') {
    return false
  }
  return true
}

export function getValidDiagnosisArrayForPrescription(diagnosisList) {
  return diagnosisList?.filter((d) => isValidDiagnosis(d, true))
}

export function preparePrescriptionDiagnosisLine(diagnosisItem) {
  let line = diagnosisItem?.label
  if (!!diagnosisItem?.duration) {
    line += ` for ${diagnosisItem?.duration}`
  }
  if (!!diagnosisItem?.date && dayjs(diagnosisItem?.date).isValid()) {
    line += `, Since: ${dayjs(diagnosisItem?.date).format('DD-MMM-YYYY')}`
  }

  return line
}

export function prepareFinalRequestedTestsSentence(finalRequestedTestsBy) {
  if (!finalRequestedTestsBy?.valueType) {
    return null
  }
  let sentence = ''

  if (finalRequestedTestsBy?.valueType === TESTS_TYPES_MAP.calendar.id) {
    // For calendar, only return if calendarValue exists
    if (!finalRequestedTestsBy?.calendarValue) {
      return null
    }
    sentence = sentence + dayjs(finalRequestedTestsBy?.calendarValue).format('DD-MM-YYYY')
  } else if (
    finalRequestedTestsBy?.valueType === TESTS_TYPES_MAP.days.id ||
    finalRequestedTestsBy?.valueType === TESTS_TYPES_MAP.months.id ||
    finalRequestedTestsBy?.valueType === TESTS_TYPES_MAP.weeks.id
  ) {
    // For days/weeks/months, only return if value is entered
    if (!finalRequestedTestsBy?.value || finalRequestedTestsBy?.value.trim() === '') {
      return null
    }
    sentence = sentence + 'in '
    sentence = sentence + finalRequestedTestsBy?.value
    if (sentence !== '') {
      sentence = sentence + ' '
    }
    sentence = sentence + TESTS_TYPES_MAP?.[finalRequestedTestsBy?.valueType]?.title
  } else {
    // For today, asap, next-visit - these don't need a value, just return the type
    sentence = TESTS_TYPES_MAP?.[finalRequestedTestsBy?.valueType]?.title || ''
  }

  return sentence
}

export function getCasedHeadingTextBasedOnStyleOverrides({ headingText, styleOverrides }) {
  if (styleOverrides?.headingCase === 'uppercase') {
    return headingText.toUpperCase()
  }
  if (styleOverrides?.headingCase === 'lowercase') {
    return headingText.toLowerCase()
  }
  if (styleOverrides?.headingCase === 'capitalize') {
    return headingText.replace(/\b\w/g, (char) => char.toUpperCase())
  }
  return headingText
}
